import React, { FunctionComponent } from 'react';

import { useTranslation } from 'react-i18next';

import 'common/beta-label/BetaLabel.scss';

interface Props {
    className?: string;
    /** default: BETA */
    text?: string;
}

export const BetaLabel: FunctionComponent<Props> = ({ className, text }) => {
    const { t } = useTranslation(['common']);

    return <span className={`r4e-beta-label ${className || ''}`}>{t(text || 'BETA')}</span>;
};
